import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import {
  Constrainer,
  HorizontalSpacer,
} from "../../internal-components/Layout.js";
import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";

const quoteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 140"
    width="90"
    height="140"
    aria-hidden="true"
  >
    <path d="M41.617 0v62.765c0 22.984-18.632 41.617-41.616 41.617V41.616C0 18.633 18.633 0 41.617 0ZM90 34.656V98.38c0 22.984-18.632 41.617-41.616 41.617V76.273c0-22.984 18.632-41.617 41.616-41.617Z" />
  </svg>
);

export interface QuoteComponentProps {
  text?: string;
  author?: string;
  hideQuoteIcon?: boolean;
}

export function Quote({
  text,
  author,
  hideQuoteIcon,
}: QuoteComponentProps) {
  return (
    <QuoteVerticalSpacer>
      <HorizontalSpacer>
        <Constrainer $width="small">
          <QuoteFigure>
            {!hideQuoteIcon && <QuoteIcon>{quoteIcon}</QuoteIcon>}
            <blockquote
              className="h2"
              {...createEditableProps("text", "text")}
            >
              {text}
            </blockquote>
            <figcaption {...createEditableProps("text", "author")}>
              {author}
            </figcaption>
          </QuoteFigure>
        </Constrainer>
      </HorizontalSpacer>
    </QuoteVerticalSpacer>
  );
}

export const QuoteVerticalSpacer = styled.div`
  margin: ${(props) => props.theme.spacing.xl} 0;
`;

export const QuoteFigure = styled.figure`
  position: relative;
  color: var(--swatch1);
  padding: ${({ theme }) => theme.spacing.l} 0;
  margin: 0;

  blockquote {
    text-align: center;
    margin: 0;
    position: relative;
    z-index: 2;
  }

  figcaption {
    margin-top: ${({ theme }) => theme.spacing.s};
    text-align: right;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${({ theme }) => `${theme.spacing.xl}px ${theme.spacing.l};`};
  }
`;

export const QuoteIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  svg {
    width: 45px;
    height: 70px;

    path {
      fill: var(--swatch3);
    }
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    svg {
      width: 90px;
      height: 140px;
    }
  }
`;
